import { Component } from "@angular/core";

@Component({
  selector: "app-coming-soon",
  templateUrl: "./coming-soon.component.html",
})
export class ComingSoonComponent {
  constructor() {}
}
